import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    fetch(`/legal/privacy-policy/privacyPolicy-2024-08-14.html`)
      .then((response) => response.text())
      .then((data) => setHtmlContent(data))
      .catch((error) => console.error("Error loading HTML file:", error));
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy - droplla</title>
        <meta name="description" content="Learn how droplla collects, uses, and protects your data. Read our privacy policy for more details." />
        <link rel="canonical" href="https://www.droplla.com/legal/privacy-policy" />
      </Helmet>
      <Box pt={8} pb={8} pl={10} pr={10} dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </>

  );
};

export default PrivacyPolicy;
